import React from 'react';
import MAINPAGE from "./core/components/mainpage";
import { Provider } from 'react-redux';
import { Stage, Sprite, Container } from '@inlet/react-pixi';
import { alllanguage, lanAssetConfig } from "./data/lang";
import * as PIXI from "pixi.js";
import Wrapper from "./core/components/wrapper/wrapper";
import Layouts from "./core/components/layouts/layouts";
import Detectdevices from "./core/components/device/detectdevices";
import { isMobile } from "react-device-detect";
import HtmlElementGenericUI from "./behaviour/htmlElementGenericUI/htmlElementGenericUI";
import ServerComm from "./serverComm/serverComm";
import CheatPanel from "./cheatPanel/cheatPanel";
import WrapperComm from "./behaviour/wrapperComm/wrapperComm";
import IntroductionInCanvas from "./components/introduction/introductionInCanvas";
import DesktopPaytable from "./components/paytable/desktopPaytable";
import Banner from "./core/components/banner/banner";
import KeyboardListener from "./core/components/keyboardListeners/keyboardListener";
import AutoplayKeyboardListener from "./behaviour/autoplayKeyboardListener/autoplayKeyboardListener";
import SoundActiveScreen from "./behaviour/soundActiveScreen/soundActiveScreen";
import ApiService from "./gameservice/api.service"
import { CURRENCY } from "./core/utills";



import MainSettingPanelComponent from "./behaviour/mainSettingPanelComponent/mainSettingPanelComponent";
import Cheat from './cheat/cheat';


window.PIXI = PIXI;

interface IProps {
    [x: string]: any;
}


interface IState {
    [x: string]: any;

    width: number,
    height: number,
    GAME_INFO: any,
    alllanguage: any
}

class GameApp extends React.Component<IProps, IState> {
    protected contentContainer: any;
    protected logoImageXInPortrait: number = 550;
    protected logoImageYInPortrait: number = 610;
    protected logoImageXInLandscape: number = 957;
    protected logoImageYInLandscape: number = 430;
    private minFullHDWidth: number = 1024;
    private HDReadyWidth: number = 1280;
    private fullHDWidth: number = 1920;
    private minFullHDPxRatio: number = 2;
    private graphicImagePage: string = "";
    private canvasBgImagePage: string = "";
    private initializeGameStart: boolean = false;

    constructor(props: any) {
        super(props);
        this.state = {
            width: this.props.width,
            height: this.props.height,
            GAME_INFO: {},
            alllanguage: {}
        }
        this.contentContainer = {}
        this.chooseAssets();
    }

    createHelpTextInTags(textData: any) {

        textData = JSON.stringify(textData);
        textData = JSON.parse(textData);


        let lenHelpTextObj = textData;
        let lenHelpTextObjLen = lenHelpTextObj.length;
        let HelpTextObject = {};
  
        if (lenHelpTextObjLen == 10) {

            lenHelpTextObj.splice(9, 0, { title: 'no buyin', "icon": "nobuyin", "body": [] })
        }
        lenHelpTextObjLen = lenHelpTextObj.length;
        for (let i = 0; i < lenHelpTextObjLen; i++) {

            let key = "tag-help-" + lenHelpTextObj[i]["icon"] + "_" + i;
            let tagWithText = { ...{ [key]: lenHelpTextObj[i]["title"] } }
            HelpTextObject = { ...HelpTextObject, ...tagWithText }

            let textList = lenHelpTextObj[i]["body"];
            let textListLen = textList.length;
            for (let j = 0; j < textListLen; j++) {
                let key = "tag-help-" + lenHelpTextObj[i]["icon"] + "_" + i + "_" + j;
                let tagWithText = { ...{ [key]: textList[j] } }
                HelpTextObject = { ...HelpTextObject, ...tagWithText }
            }

        }
        return HelpTextObject;


    }
    componentDidMount() {


        // window.addEventListener('resize', this.updateDimensions.bind(this));
        // this.contentResize();
        console.warn = () => {};
        window.addEventListener('load', (event) => {

           
            ((window as any).GAME_INFO).loginComplete.then(() => {
                //Initialise game
                // this.initializeGameStart = true;
                // // (window as any).GAME_INFO.force = true;
                // this.setState((prevState) => {
                //     return {
                //         ...prevState,

                //         GAME_INFO: (window as any).GAME_INFO
                //     }
                // }, this.contentResize);
                // window.addEventListener('resize', this.updateDimensions.bind(this));
                // this.contentResize();


                let lang_1: any = {};
                let lang_2: any = {};
                let lang_3: any = {};
                this.sendLanguageResponse()
                    .then((result: any) => {
                        lang_1 = result.data;
                        this.sendLanguageResponse2()
                            .then((result: any) => {
                                lang_2 = result.data;
                                this.sendLanguageResponse3()
                                    .then((result: any) => {
                                        lang_3 = result.data;

                                        lang_3 = this.createHelpTextInTags(lang_3);

                                        this.initializeGameStart = true;

                                        let merged = { ...lang_1, ...lang_2, ...lang_3 };
                                        this.setState((prevState) => {
                                            return {
                                                ...prevState,
                                                alllanguage: merged,
                                                GAME_INFO: (window as any).GAME_INFO
                                            }
                                        }, this.contentResize);
                                        window.addEventListener('resize', this.updateDimensions.bind(this));
                                        this.contentResize();
                                    })
                                    .catch((error: any) => { console.error(error); return Promise.reject(error); });


                            })
                            .catch((error: any) => { console.error(error); return Promise.reject(error); });


                    })
                    .catch((error: any) => { console.error(error); return Promise.reject(error); });


            })

        });

    }
    sendLanguageResponse() {
        //let url = "https://www.1x2-cloud-1.com/f1x2games/properties/BONANZA/lang/common/" + (window as any).GAME_INFO.lang + ".json";
        let url = (window as any).GAME_INFO.pathCDN + "properties/BONANZA/lang/common/" + (window as any).GAME_INFO.lang + ".json";
        const api = new ApiService(url);

        return api.get(url, {});

    }
    sendLanguageResponse2() {
        //let url = "https://www.1x2-cloud-1.com/f1x2games/properties/BONANZA/lang/superrainbowmegaways/" + (window as any).GAME_INFO.lang + ".json";
        let url = (window as any).GAME_INFO.pathCDN + "properties/BONANZA/lang/" + (window as any).GAME_INFO.folderName + "/" + (window as any).GAME_INFO.lang + ".json";
        const api = new ApiService(url);

        return api.get(url, {});

    }
    sendLanguageResponse3() {
        //let url = "https://www.1x2-cloud-1.com/f1x2games/properties/BONANZA/lang/superrainbowmegaways/" + (window as any).GAME_INFO.lang + ".json";
        let url = (window as any).GAME_INFO.pathCDN + "properties/BONANZA/help/" + (window as any).GAME_INFO.gameID + "/" + (window as any).GAME_INFO.lang + ".json";
        // let url = "http://www.1x2-cloud-1.com/f1x2games/properties/BONANZA/help/8308/en.json"
        //let url ="http://www.1x2-cloud-1.com/f1x2games/properties/BONANZA/help/8108/de.json"
        const api = new ApiService(url);

        return api.get(url, {});

    }
    //  Result = sendLanguageResponse();

    //  Result = Result
    //     .then((result: any) => { console.log("yahoo 1 lang", result.data);allLang=result.data; return result.data; })
    //     .catch((error: any) => { console.error(error); return Promise.reject(error); });
    updateDimensions() {
        if (isMobile) {

            if (window.innerHeight > window.innerWidth) {

                this.setState((prevState) => {
                    return {
                        ...prevState,
                        width: this.props.constant.configGame.portraitCanvasWidth,
                        height: this.props.constant.configGame.portraitCanvasHeight,
                    }
                }, this.contentResize)
            } else {

                this.setState((prevState) => {
                    return {
                        ...prevState,
                        width: this.props.constant.configGame.landscapeCanvasWidth,
                        height: this.props.constant.configGame.landscapeCanvasHeight,
                    }
                }, this.contentResize)


            }
        } else {


            this.setState((prevState) => {
                return {
                    ...prevState,
                    width: this.props.constant.configGame.canvasWidth,
                    height: this.props.constant.configGame.canvasHeight,
                }
            }, this.contentResize)
        }
    }

    contentResize() {

        let viewWidth, viewHeight, detectDevices = new Detectdevices();
        if (detectDevices.isHandheld() === true && detectDevices.isSafariBrowser() === false) {
            if (detectDevices.isIOS9Mobile() === true) {
                viewWidth = window.outerWidth;
                viewHeight = window.outerHeight;
            } else {
                viewWidth = Math.min(document.documentElement.clientWidth, window.outerWidth || 0);
                viewHeight = Math.min(document.documentElement.clientHeight, window.outerHeight || 0);
            }
        } else {
            if (isMobile) {

                viewWidth = window.outerWidth;
                viewHeight = window.outerHeight;
            } else {
                viewWidth = window.innerWidth;
                viewHeight = window.innerHeight;
            }

        }

        let gameCanvas: any = document.getElementById('gameCanvas');
        let ctx: any = gameCanvas.getContext('2d');

    }
    chooseAssets() {
        let screen = window.screen

        let isFullHD = false;
        // FullHD atlas will be loaded on devices whose base resolution is greater than 1024px width and its pixel ratio (density) is greater than 1 (https://mydevice.io/devices/)
        // In the case of computer screens which normally have a pixel ratio of 1, it will be checked if the base resolution is HDReady or FullHD to load the fullHD atlas
        if (((screen.width >= this.minFullHDWidth || screen.height >= this.minFullHDWidth) && window.devicePixelRatio >= this.minFullHDPxRatio) ||
            (screen.width >= this.HDReadyWidth || screen.height >= this.HDReadyWidth)) {
            isFullHD = true;
        }
        if (isFullHD) {
            this.graphicImagePage = "HD/assets/loader/graphic.png";
            this.canvasBgImagePage = "HD/assets/commongame/basegame_2048.jpg";
        } else {
            this.graphicImagePage = "LD/assets/loader/graphic.png";
            this.canvasBgImagePage = "LD/assets/commongame/basegame_2048.jpg";

        }
    }
    loaderUi() {
        let loaderScreenImageX = this.logoImageXInLandscape, loaderScreenImageY = this.logoImageYInLandscape, scaleProps;
        if (isMobile) {
            if (window.innerHeight > window.innerWidth) {
                loaderScreenImageX = this.logoImageXInPortrait;
                loaderScreenImageY = this.logoImageYInPortrait;
                scaleProps = 0.8;
            } else {
                loaderScreenImageX = this.logoImageXInLandscape;
                loaderScreenImageY = this.logoImageYInLandscape;
                scaleProps = 1;
            }
        }
        return (<Container>
            <Sprite x={loaderScreenImageX} y={loaderScreenImageY} scale={scaleProps}
                image={this.graphicImagePage} anchor={[0.5, 0.5]}></Sprite>
        </Container>)
    }



    useQuery = () => {
        let search = window.location.search;
        return new URLSearchParams(search);
    }
    setQueryStringParameter() {

        let langcode = this.useQuery().get("lang");
        let currCode = (window as any).GAME_INFO.currency;//this.useQuery().get("currency");

        let cheatEnable = (window as any).GAME_INFO.force;//this.useQuery().get("cheatEnable");
        if (this.useQuery().get("cheatEnable") == "true") {
            cheatEnable = true;
        }
        // let langcode,currCode;
        if (langcode === undefined || langcode === null || langcode === "") {
            langcode = "en";
        }
        if (currCode === undefined || currCode === null || currCode === "") {
            currCode = "GBP";
        }
        // localStorage.setItem("langCode", langcode || "en");
        // localStorage.setItem("currCode", currCode || "GBP");
        // localStorage.setItem("cheatEnable", cheatEnable || "false");
        this.props.constant.configGame.langCode =langcode || "en";
        this.props.constant.configGame.currCode =currCode || "GBP";
        this.props.constant.configGame.cheatEnable =cheatEnable || false;
        
       
        CURRENCY.CurrencyManager.setCurrency({
            currency: {
                code: currCode,
                maj: "?",
                min: "p",
                gs: ",",
                ds: ".",
                scale: "1",
                gp: 3,
                dp: 2,
                msp: true,
            }
        })
    }

    getGameStart() {
        if (!this.initializeGameStart) {
            return (<></>)
        }

        this.setQueryStringParameter();
        // let langCode = localStorage.getItem("langCode")
        // let cheatEnable: boolean = localStorage.getItem("cheatEnable") == "true"
       
        let langCode = this.props.constant.configGame.langCode;
        let cheatEnable: boolean = this.props.constant.configGame.cheatEnable;
        

        // alert("cheatEnable:"+cheatEnable)


        let { width, height, alllanguage } = this.state;

        const langObj: Record<any, any> = alllanguage;//[langCode as keyof typeof alllanguage];
        let PROPS_TO_SEND_MAINPAGE = {
            langCode: langCode,
            langObj: langObj,
            constant: this.props.constant,
            detectDevices: new Detectdevices(),
            lanAssetConfig: lanAssetConfig,
            width: width,
            height: height,
            configGame: this.props.configGame,
            LOADERUI: this.loaderUi()

        }
        let PROPS_TO_SEND_HtmlElementGenericUI = {
            langCode: langCode,
            langObj: langObj,
            constant: this.props.constant,
            detectDevices: new Detectdevices(),
            lanAssetConfig: lanAssetConfig,
            width: this.props.configGame.CANVAS_WIDTH,
            height: this.props.configGame.CANVAS_HEIGHT,
            configGame: this.props.configGame,


        }
        return (
            <div>

                <div id={"bg"}>
                    <img className={"canvasBgImage"} id={"canvasBgImageId"} src={this.canvasBgImagePage} width={window.innerWidth + 'vw'} height={window.innerHeight + 'vh'} ></img>
                </div>

                <Stage id={"gameCanvas"} width={width} height={height}>
                    <Provider store={this.props.Gamestore}>
                        <Container ref={i => this.contentContainer = i}>
                            <WrapperComm {...PROPS_TO_SEND_MAINPAGE}></WrapperComm>
                            <MAINPAGE {...PROPS_TO_SEND_MAINPAGE} />
                            {/* {cheatEnable && <CheatPanel {...PROPS_TO_SEND_MAINPAGE}></CheatPanel>} */}
                            <SoundActiveScreen {...PROPS_TO_SEND_MAINPAGE}></SoundActiveScreen>
                            <IntroductionInCanvas {...PROPS_TO_SEND_MAINPAGE}></IntroductionInCanvas>

                            <DesktopPaytable {...PROPS_TO_SEND_MAINPAGE}
                            ></DesktopPaytable>

                            {/*    {isMobile && <MainSettingPanelComponent {...PROPS_TO_SEND_MAINPAGE}
                            ></MainSettingPanelComponent>}
 */}

                            {/*<Banner langCode={langCode} langObj={langObj} constant={this.props.constant}*/}
                            {/*        configGame={this.props.configGame}*/}
                            {/*        detectDevices={new Detectdevices()} lanAssetConfig={lanAssetConfig}*/}
                            {/*        width={width}*/}
                            {/*        height={height} bannerType={"Intro"}></Banner>*/}


                        </Container>

                    </Provider>
                </Stage>
                <Provider store={this.props.Gamestore}>

                    <HtmlElementGenericUI {...PROPS_TO_SEND_HtmlElementGenericUI}></HtmlElementGenericUI>

                    <Wrapper {...PROPS_TO_SEND_HtmlElementGenericUI}></Wrapper>
                    <ServerComm></ServerComm>
                    <Layouts></Layouts>
                    <KeyboardListener {...PROPS_TO_SEND_HtmlElementGenericUI}></KeyboardListener>
                    {<AutoplayKeyboardListener {...PROPS_TO_SEND_HtmlElementGenericUI}></AutoplayKeyboardListener>}
                </Provider>
                <div id={"cheat-section"} style={{ visibility: cheatEnable ? "visible" : "hidden" }}>
                    <Cheat></Cheat>
                </div>
            </div>
        );
    }


    render() {
        return (this.getGameStart());
    }
}


export default GameApp;

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();

//https://www.youtube.com/watch?v=CVpUuw9XSjY

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
